<template>
	<main
		id="app"
		v-cloak
	>
		<app-header />
		<router-view />
	</main>
</template>

<style lang="scss">
@import "src/scss/app.scss";
</style>

<script>
// @ is an alias to /src
import AppHeader from "@/components/AppHeader.vue";

export default {
	components: {
		AppHeader
	}
};
</script>
